// Single source of truth for "is this URL a customer-facing page?" — the
// surfaces fans reach by scanning a talent's QR code or share link:
//   /dj/:slug            public profile
//   /dj/:slug/request    request page (the QR target)
//   /:slug               short link straight to the request page
//   /success, /free-success   legacy post-payment URLs (redirect to /fan/requests)
// The Header hides Login / Sign Up and the talent nav on these — a fan
// mid-request shouldn't be invited to create a talent account.

/** Every first URL segment the app claims for its own routes. A
 *  single-segment path whose first segment is NOT in this set falls through
 *  to the `/:slug` catch-all route, i.e. it IS a customer request page.
 *  Keep in sync with the routes in App.tsx. */
export const APP_FIRST_SEGMENTS = new Set([
  "learn-more", "privacy", "terms", "sms", "about", "welcome", "first-run-tour", "download", "app",
  "login", "register", "forgot-password", "reset-password",
  "profile", "balance", "more", "requests", "payout-history", "leaderboard", "qr",
  "admin", "admin-login", "verify", "dj", "venue",
  "success", "free-success", "receipt", "playlist",
  "finish-stripe", "stripe-rejected", "disputes", "claims", "fan", "join",
  // Spotlight screen links: /s/<code> (pages/spotlight, mounted from boot.tsx).
  "s",
]);

export const isCustomerPage = (pathname: string): boolean => {
  if (pathname.startsWith("/dj/")) return true;
  // /fan/* (magic-link landing) is a fan surface: wordmark + chip, never
  // the talent nav.
  if (pathname.startsWith("/fan/") || pathname === "/fan") return true;
  if (pathname === "/success" || pathname === "/free-success") return true;
  const segments = pathname.split("/").filter(Boolean);
  return segments.length === 1 && !APP_FIRST_SEGMENTS.has(segments[0]);
};
